import React from 'react'

function Refunds() {
    return (
        <div class="idocs-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                    <section id="idocs_faq">
                        <h1>Refunds</h1>
                        <hr/>
                        <p class="mt-30">
                           Safexpay Payment Gateway offers a simple, fast and robust refund policy to its users. 
                        </p>
                        <p>
                           Now make your payment transfers with ease and peace of mind!
                        </p>
                        <h5>Key Features:</h5>
                        <ul>
                           <li><b>Initiate a refund request directly from the Safexpay dashboard:</b><br/>
                              which eliminates the need to contact customer support or navigate through a complex refund process. This feature saves time and effort of both he customers and merchants involved.
                           </li>
                           <li>
                              <b>Issue partial refunds: </b><br/>
                              Of specific amounts to customers rather than the entire transaction amount. Now, gain the flexibility and convenience to carry out your refund process, making it easier to resolve issues and keep track of your cashflows.
                           </li>
                           <li>
                              <b>Offer a seamless refund experience </b>to their customers while maintaining positive relationships and protecting their bottom line.
                           </li>
                        </ul>
                     </section>
                    </div>
                    <div class="col-md-4">
                        
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Refunds